import type { PollsLeftMap } from '../types';

const usePollsLeftMap = () => {
  // Store in the window object
  let pollsLeftMap: PollsLeftMap = window.pollsLeftMap;
  if (!pollsLeftMap) {
    pollsLeftMap = new Map();
    window.pollsLeftMap = pollsLeftMap;
  }
  return [pollsLeftMap];
};

export default usePollsLeftMap;
